<template>
    <div class="apprentice-simple-card">
        <div class="internship-overview">
            <design-2021-internships-student-signup-index-component
                v-if="!internship || (internship && internship.pivot.status === 0)"
                :google-map-api="googleMapApi"
                :internships-in="internships"
                :project-in="projectIn"
                @update-signed-internship="updateSignedInternship">
            </design-2021-internships-student-signup-index-component>

            <design-2021-internships-student-signed-internship-component
                v-else
                :google-map-api="googleMapApi"
                :internship-in="myInternship"
                :project-in="projectIn"
                @signOut="signOut"
                @updateInternship="updateInternship($event)"
                @show-assignments="showAssignments">
            </design-2021-internships-student-signed-internship-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internship-report-show-internship-component',
    props: ['projectIn', 'groupIn', 'googleMapApi'],
    data() {
        return {
            project: this.projectIn,
            internship:
                this.projectIn.internship[0] && this.projectIn.internship[0].pivot.status !== 0
                    ? this.projectIn.internship[0]
                    : null,
            internships: [],
        };
    },

    mounted() {
        this.internship =
            this.projectIn.internship[0] && this.projectIn.internship[0].pivot.status !== 0
                ? this.projectIn.internship[0]
                : null;
        if (this.internship) {
            this.internship.internship_agreement = this.groupIn.internship_agreement;
        } else {
            this.getInternships();
        }
    },

    computed: {
        myInternship() {
            return this.internship;
        },
    },

    methods: {
        updateSignedInternship(project) {
            this.internship = project.internship[0];
            this.internship.internship_agreement = this.groupIn.internship_agreement;
            this.$emit('signedUp', project);
        },

        signOut() {
            this.internship = null;
            this.getInternships();
        },

        updateFilter(filters) {
            this.filters = { ...filters };
        },

        getInternships() {
            this.axios.get(this.routes.groupInternships(this.groupIn.id)).then(
                (response) => {
                    this.internships = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        showAssignments() {
            this.$emit('show-assignments');
        },
        updateInternship(internship) {
            internship.pivot = this.internship.pivot;
            this.internship = internship;
        },
    },
};
</script>

<style lang="scss" scoped>
#student-internship-apply-modal___BV_modal_outer_ ::v-deep {
    .modal-dialog {
        .modal-content {
            .modal-header {
                position: relative;
                padding: 0;
                height: 250px;
                border-top-right-radius: $border-radius-content;
                border-top-left-radius: $border-radius-content;

                .btn-close {
                    position: absolute;
                    top: 12px;
                    right: 12px;
                    font-size: 1.5625rem;

                    &:before {
                        margin-right: 0;
                        font-weight: $font-weight-normal;
                    }
                }
            }
        }
    }
}

.header,
.gg-map-location {
    width: 100%;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
}

.header {
    height: 100%;
}

.tags-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 10px;

    .tag {
        padding: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'eight');
        font-size: 0.8125rem;
    }
}

.description {
    color: $text-muted-color;
    line-height: 1.3;
    font-size: $base-font-size;
    margin-top: map-get($grid-gutter-spacing, 'ten');
    margin-bottom: $grid-gutter-width;
}

.gg-map-location {
    height: 200px;
}

.motivation {
    margin-top: map-get($grid-gutter-spacing, 'sixty');
}

.internship-show-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    > .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }
}

.add-internship {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .btn-add-internship {
        flex-direction: column;

        &:before {
            margin-right: 0;
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
        }
    }
}

.empty-internship-list {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
